module.exports = __webpack_public_path__ + "img/cooperation_banner.fd681b51.jpg";